import { render } from "./Flex.vue?vue&type=template&id=cc171e5e"
import script from "./Flex.vue?vue&type=script&lang=ts"
export * from "./Flex.vue?vue&type=script&lang=ts"

import "./Flex.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script